/*
 File: slide-tracking.js
 Author: D McCleod
 Created: 2/15/2017
 Modified: 12/06/2018
 Description: fire tracking calls based on element data attributes and on 'swipe'
 */

import { scrollTo } from './slider-events';
import{ getHash } from './hash-manager';
import { sticky } from './sticky-header';

function initModularTracking(){
    // TODO:  for back end, add the data-track attribute back into the XSLT (where it used to be)
    let downloadPPT = $('.crs-utils__download a').attr('data-track', 'ss-download_ppt');
    $('[data-track]').on('click', trackHandler);
}

function trackHandler(){
    let trackTag = $(this).data('track');
    wmdPageLink(trackTag);
    return trackTag;
}

function virtualTracking(navEvent){
    pageRefresh(navEvent.data);
}

function dataTracking() {
    // set handler for all nav arrows
    $('[data-virtual-track]').on('click', function(event) {
        slideShow.navEvent.type = event.type;
        slideShow.navEvent.data = event.currentTarget.dataset.virtualTrack;
        slideShow.slickNavEngaged = true;
        if(sticky.props.classSet) scrollTo(sticky.props.returnHeight);
    });
}

function pageRefresh(trackValue) {
    let trackurl = window.slideShow.cononical,
    param = trackValue.indexOf('ss_intad') !== -1 ? {ad: true, value: trackValue, number: getHash()} : getHash(),
    hashPromise = new Promise(function(resolve, reject){
        resolve(param);
        reject(Error('hash not returned'));
    });

    hashPromise.then(function(hash) {
        // check for presense of ad property if passed in hash
        let isAd = hash.ad !== undefined,
        urlHash = isAd ? hash.number + '-sp' : hash;
        hash = isAd ? hash.value : hash;

        $(document).one( "pvidReset", {
            wmdPV1: trackurl+ "#" + urlHash,
            wmdPV2: hash,
            wmdT: trackValue
        }, function( event ) {
            if (typeof profads !== "undefined" && profads.ads2.KillSwitch()) {
                if(breakpoint === 1 && !isAd) {
                    // do not refresh 1005 on content marketing
                    if (!slideShow.useContentMrk) webmd.ads2.refresh({pos:1005, keys: {pvid:s_pageview_id, ep:'0'}});
                } else if(breakpoint !== 1 && !isAd) {
                    webmd.ads2.refresh({keys: {pvid:s_pageview_id, ep:'0'}});
                }
            }
            wmdTrack(event.data.wmdT);
            wmdPageview(event.data.wmdPV1,event.data.wmdPV2);
        });

        GenPVID();
        BItrack(urlHash);
    });
}


export { initModularTracking, virtualTracking, dataTracking };

